const zIndex = {
    low: 1,
    medium: 10,
    high: 99,
    highest: 1000,
};
export default zIndex;
//# sourceMappingURL=zIndex.js.map